import React from 'react';
import Modal from './Modal';

export default function ConfirmModal({ open, onClose, onConfirm, title = 'Are you sure?', message = 'This action cannot be undone.', confirmLabel = 'Delete', danger = true }) {
  return (
    <Modal open={open} onClose={onClose} title="" width={340}>
      <div style={{ textAlign: 'center', padding: '8px 0' }}>
        <div style={{ width: 46, height: 46, borderRadius: '50%', background: danger ? '#faeaea' : '#e6f4ec', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
          {danger
            ? <svg width="20" height="20" viewBox="0 0 16 16" fill="none" stroke="#dc3545" strokeWidth="1.5"><polyline points="2,4 14,4" /><path d="M5 4V2h6v2M6 7v5M10 7v5" /><rect x="3" y="4" width="10" height="10" rx="1" /></svg>
            : <svg width="20" height="20" viewBox="0 0 16 16" fill="none" stroke="#037b3e" strokeWidth="1.5"><rect x="1" y="4" width="14" height="10" rx="1" /><path d="M1 4l2-3h10l2 3" /><line x1="6" y1="8" x2="10" y2="8" /></svg>
          }
        </div>
        <h3 style={{ fontSize: 15, fontWeight: 600, color: '#343a40', marginBottom: 8 }}>{title}</h3>
        <p style={{ fontSize: 13, color: '#6c757d' }}>{message}</p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginTop: 18 }}>
          <button type="button" onClick={onClose} style={{ padding: '7px 18px', borderRadius: 6, border: '1px solid #ced4da', background: '#fff', cursor: 'pointer', fontSize: 13 }}>Cancel</button>
          <button type="button" onClick={() => { onConfirm(); onClose(); }}
            style={{ padding: '7px 18px', borderRadius: 6, border: 'none', background: danger ? '#dc3545' : '#037b3e', color: '#fff', cursor: 'pointer', fontSize: 13 }}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
